/** Pure helpers for the Verification v2 who/when display (item 4). */

/** Format the verified_at ISO timestamp to a YYYY-MM-DD stamp (UTC-stable so
 *  the string is deterministic across timezones / test runs). Falls back to the
 *  raw input if it is not a parseable date. */
function formatStampDate(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return d.toISOString().slice(0, 10)
}

/** Build the "Verified by <who> · <date>" line, or `null` when it must not show.
 *
 *  STALE-STAMP GUARD (brief-mandated): a downgraded record (needs_review /
 *  flagged / unverified) KEEPS its verified_by/verified_at — the backend
 *  preserves the stamp on auto-downgrade so the audit trail survives. Presenting
 *  that as "Verified by …" would read as verified. So the who/when line is
 *  surfaced ONLY when the record is currently `verified`. */
export function formatVerifiedBy(
  status: string | null | undefined,
  verifiedBy: string | null | undefined,
  verifiedAt: string | null | undefined,
): string | null {
  if (status !== 'verified') return null
  if (!verifiedBy && !verifiedAt) return null
  const who = verifiedBy ?? 'unknown'
  const when = verifiedAt ? formatStampDate(verifiedAt) : null
  return when ? `Verified by ${who} · ${when}` : `Verified by ${who}`
}
